import { render, staticRenderFns } from "./ModalAdminList.vue?vue&type=template&id=32b4a689&scoped=true"
import script from "./ModalAdminList.vue?vue&type=script&lang=js"
export * from "./ModalAdminList.vue?vue&type=script&lang=js"
import style0 from "./ModalAdminList.vue?vue&type=style&index=0&id=32b4a689&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b4a689",
  null
  
)

export default component.exports